//import React from 'react';
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import styled, { createGlobalStyle } from "styled-components";
import { processDomainDataLists, getDateStringFromWeek } from './DealsDataHelper';
//import { getDealSpecials } from "../../actions/dealsActions";



// import { bindActionCreators } from "redux";

// import { performThumbnailSearch } from "../../actions/thumbnailActions";

import TextFieldGroup from "../common/TextFieldGroup";
import SelectCategoryGroup from "../common/SelectCategoryGroup";
import DoubleSlider from "./DoubleSlider";
import DateSlider from "./DateSlider";
import TestDataDisplay from "./TestDataDisplay";

import Modal from "react-responsive-modal";

/* Positional alignment */
/*
// justify-content: center;     /* Pack items around the center */
// justify-content: start;      /* Pack items from the start */
// justify-content: end;        /* Pack items from the end */
// justify-content: flex-start; /* Pack flex items from the start */
// justify-content: flex-end;   /* Pack flex items from the end */
// justify-content: left;       /* Pack items from the left */
// justify-content: right;      /* Pack items from the right */

/* Baseline alignment */
/* justify-content does not take baseline values */

/* Normal alignment */
// justify-content: normal;

// /* Distributed alignment */
// justify-content: space-between; /* Distribute items evenly
//                                    The first item is flush with the start,
//                                    the last is flush with the end */
// justify-content: space-around;  /* Distribute items evenly
//                                    Items have a half-size space
//                                    on either end */
// justify-content: space-evenly;  /* Distribute items evenly
//                                    Items have equal space around them */
// justify-content: stretch;       /* Distribute items evenly
//                                    Stretch 'auto'-sized items to fit
//                                    the container */

const JJV = styled("div")`
  display: inline-block;
  height: 18px;
  width: 90%;
  margin: 0 5%;
  color:white;
  font-size:16pt;
`;

//justify-content: space-evenly;
const Flexouter = styled("div")`
display: flex;
flex-direction: row;
justify-content: space-between;
border: 1px solid blue;
width: 400px;
`;
// flex: 0 0 50 %;


const Flexinner = styled("div")`
background-color: white;
padding: 5px;
border:1px solid black;
margin:3px;

`;

const Flexcol = styled("div")`
display: flex;
flex-direction: column;
justify-content: space-between;
border: 1px solid blue;

`;



const Flexinnera = styled("div")`

max-width: 50%;
background-color: white;
padding: 5px;
border:1px solid black;
margin:5px;
`;
const Flexinner2 = styled("div")`
flex: 0 0 50 %;
max-width: 50 %;
margin-top: 50px;
background-color: white;
padding: 5px;
border-radius: 10px;
box-shadow: 4px 4px 6px #231259;
`;



class Test extends Component {
  constructor(props) {
    super(props);
    //  console.log("passed in props", props.minmax);
    this.state = {
      displaystr: 'what',
      displaystr2: 'what2',
      deals: [],
      errors: {}
    };
  }
  componentDidMount() {
  }

  showDetails = () => {
    let link = "/api/deals/props_acoms_photos";
    let link2 = "/api/deals/props_acoms_photos_unwind";

    let qobj = {};
    axios
      .post(link, qobj)
      //.get(link2)
      .then(res => {
        console.log(res);
        let rstr = JSON.stringify(res.data);
        this.setState({ displaystr: rstr });
        //console.log("getAdvertisements we have success", res.data);
        //this.setState({ businesses: res.data });
        // console.log('actions res length ', res.data.length);
        // if (res.data.length > 100) {
      }).catch(err => {
        console.log("advertise actions error ", err);

      });

  }

  showDetails2 = () => {
    let link = "/api/deals/props_acoms_photos";
    //let link2 = "/api/deals/accommodations";
    let link2 = "/api/deals/props_acoms_photos_unwind";

    let qobj = {};
    axios
      .post(link, qobj)
      //.get(link2)
      .then(res => {
        console.log(res);
        let rstr = JSON.stringify(res.data);
        this.setState({ displaystr2: rstr });
        //console.log("getAdvertisements we have success", res.data);
        //this.setState({ businesses: res.data });
        // console.log('actions res length ', res.data.length);
        // if (res.data.length > 100) {
      }).catch(err => {
        console.log("advertise actions error ", err);

      });

  }

  showDetails3 = () => {
    let link = "/api/deals/props_acoms_photos";
    //let link2 = "/api/deals/accommodations";
    // let link2 = "/api/deals/prop_acom_photo_test";
    let link2 = "/api/deals/prop_acom_photo_test_find";
    // prop_acom_photo_test_find

    let qobj = {};
    axios
      .post(link2, qobj)
      //.get(link2)
      .then(res => {
        console.log(res);
        let rstr = JSON.stringify(res.data);
        //this.setState({ displaystr3: rstr, deals: res.data });
        //console.log("getAdvertisements we have success", res.data);
        //this.setState({ businesses: res.data });
        // console.log('actions res length ', res.data.length);
        // if (res.data.length > 100) {
      }).catch(err => {
        console.log("advertise actions error ", err);

      });

  }

  modifyKey = () => {
    let link = "/api/deals/props_acoms_photos";
    //let link2 = "/api/deals/accommodations";
    // let link2 = "/api/deals/prop_acom_photo_test";
    let link2 = "/api/deals/populate_property_key";
    // prop_acom_photo_test_find

    let qobj = {};
    axios
      .get(link2)
      //.get(link2)
      .then(res => {
        console.log(res);
        let rstr = JSON.stringify(res.data);
        //this.setState({ displaystr3: rstr, deals: res.data });
        //console.log("getAdvertisements we have success", res.data);
        //this.setState({ businesses: res.data });
        // console.log('actions res length ', res.data.length);
        // if (res.data.length > 100) {
      }).catch(err => {
        console.log("advertise actions error ", err);

      });

  }




  //let link = `/ api / business / find - business / ${ bizid } `;
  render() {
    const { errors } = this.state;
    const { displaystr } = this.state;
    const { displaystr2 } = this.state;
    const { displaystr3 } = this.state;
    const { deals } = this.state;

    let template = deals.map((deal, index) => (
      <div key={index}>
        <TestDataDisplay
          data={deal}
        />
      </div>
    ));


    return (
      <div id="xxquerybar" className="container"
        style={{
          width: "95%",
          minHeight: "400px",
          paddingBottom: "10px",
          backgroundColor: "white",
          marginTop: "20px",
          fontSize: "9pt"
        }}
      >






        <p>{displaystr}</p>
        <hr />
        <p>{displaystr2}</p>
        <hr />
        <p>{displaystr3}</p>
        {template}


        <div className="row">

          <div className="col-md-1">
            <div>
              <a className="btn btn-xs btn-info"
                href="#" onClick={(e) => this.showDetails()} >details</a>
            </div>

          </div>
          <div className="col-md-1">
            <div>
              <a className="btn btn-xs btn-info"
                href="#" onClick={(e) => this.showDetails2()} >details 2</a>
            </div>

          </div>
          <div className="col-md-1">
            <div>
              <a className="btn btn-xs btn-info"
                href="#" onClick={(e) => this.showDetails3()} >details 3</a>
            </div>

          </div>
          <div className="col-md-1">
            <div>
              <a className="btn btn-xs btn-info"
                href="#" onClick={(e) => this.modifyKey()} >modify key</a>
            </div>

          </div>

        </div>
      </div>
    );
  }
}




//export default withRouter(Advertisements);
const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
  deals: state.deals,
  // mimereducer: state.mimereducer,
});

export default connect(mapStateToProps, {


})(withRouter(Test));

/*

 <Flexouter>
          <Flexinner>what</Flexinner>
          <Flexinner>what this is a very long line and lets see what happens when it wraps</Flexinner>
          <Flexinner>what</Flexinner>

        </Flexouter>
        <Flexouter>
          <Flexinner>what</Flexinner>
          <Flexinner>what this is a very long line</Flexinner>
          <Flexinner>what</Flexinner>
        </Flexouter>
        <Flexouter>
          <Flexinner>what</Flexinner>
          <Flexinner>what this is a very long line with only two elements</Flexinner>
        </Flexouter>
        <Flexouter>
          <Flexinner>what</Flexinner>
          <Flexcol>what this is a </Flexcol>
        </Flexouter>
        <Flexinner>outer</Flexinner>

        <JJV>not good</JJV>

        <div style={{ width: "400px" }}>
          <div className="flex_row">
            <div>one</div>
            <div>two</div>
            <div>three</div>
          </div>
          <div className="flex_col">
            <div>one</div>
            <div>two</div>
            <div>three</div>
          </div>
        </div>

        <div style={{ width: "400px" }}>
          <div className="flex_row">
            <div>one</div>
            <div>two</div>
            <div className="flex_col">
              <div>one</div>
              <div>two</div>
              <div>three</div>
            </div>
          </div>
          <div className="flex_col">
            <div>one</div>
            <div>two</div>
            <div>three</div>
          </div>
        </div>

        <div style={{ width: "400px" }}>
          <div className="flex_row">
            <div>one</div>
            <div>two</div>
            <div className="flex_col">
              <div className="flex_row">
                <div>one</div>
                <div>two</div>
              </div>
              <div className="flex_row">
                <div>three</div>
                <div>four</div>
              </div>
            </div>
          </div>

        </div>


  // onChange(e) {
            //   this.setState({ searchterm: e.target.value });
            // }
            onCat0Select(e, cat) {
            let cat0list = document.getElementsByClassName("cat0nav");
    window.scrollTo(0, 0);
    for (var i = 0; i < cat0list.length; {
            let el = cat0list[i];
      el.classList.remove("navpicked");
    }
    let which = e.target;
    which.classList.add("navpicked");

    e.preventDefault();
  }

  onCat1Select(e, cat1) {
            e.preventDefault();
    let fobj = { };
    fobj = {cat0: this.state.cat0, cat1: cat1 };
    // let catlist2 = list_helper.getCat2(cat1);
    // if (catlist2.length > 0) {
            //   this.setState({ cat1: cat1, cat2_list: catlist2 });
            // } else {
            //console.log("we have no cat2 list so we run ", fobj);
            //this.props.getCategoryMimes(fobj);
            // }
            //console.log(typelist2);
          }

  onCat1SelectMoreList(cat1) {
            // console.log("more list onCat1SelectMoreList ", cat1);
            // this.setState({ showmore: false });
            // this.props.getCat1Mimes(cat1);
          }

  onCat2Select(e, cat2) {
            e.preventDefault();
    let fobj = { };
    fobj = {cat0: this.state.cat0, cat1: this.state.cat1, cat2: cat2 };
    // console.log("select cat2", fobj);

    // this.props.getMimes(fobj);
  }

*/

/*

  oldprocessDomainData(dary) {
            // ddobj['query'] = { '_id': '$city' };
            // ddobj['query'] = { '_id': '$state' };
            // ddobj['query'] = { '_id': '$lok' };
            // ddobj['query'] = { '_id': '$ppn' };
            // ddobj['query'] = { '_id': '$start_date' };
            // ddobj['query'] = { '_id': '$bedrooms' };
            let tary = [];
    let cary = [];
    let sary = [];
    let lary = [];
    let pary = [];
    let sdary = [];
    let bary = [];
    tary = dary[0];
    tary.forEach(el => {
            cary.push(el['_id']);
    })
    tary = dary[1];
    tary.forEach(el => {
            sary.push(el['_id']);
    })
    tary = dary[2];
    tary.forEach(el => {
            lary.push(el['_id']);
    })
    tary = dary[3];
    tary.forEach(el => {
            pary.push(el['_id']);
    })
    tary = dary[5];
    tary.forEach(el => {
            bary.push(el['_id']);
    })

    // let cary = dary[0];
    // let sary = dary[1];
    //lary = dary[2];
    // pary = dary[3];
    sdary = dary[4];
    // bard = dary[5];

    this.setState({'city_list': cary, 'state_list': sary, 'lok_list': lary, 'ppn_list': pary, 'bedroom_list': bary });


  }
*/



// WEBPACK FOOTER //
// ./src/components/deals/Test.js